module.exports = __webpack_public_path__ + "img/17.a39bce8c.jpg";